export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyC4bK_fgiw5A3hLuPsQP_ZFBwKZFXBwDTg",
  authDomain: "randoma11y.firebaseapp.com",
  databaseURL: "https://randoma11y.firebaseio.com",
  projectId: "randoma11y",
  storageBucket: "randoma11y.appspot.com",
  messagingSenderId: "968156230845",
  appId: "1:968156230845:web:eeac0f4bb9e926ba"
}
